<template>
  <div class="scroll-arrows">
    <span class="scroll-arrow arrow-top"></span>
    <span class="scroll-arrow arrow-bottom"></span>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.scroll-arrows {
  display: flex;
  align-items: center;
  flex-flow: column;
  margin-top: 30px;
}
.scroll-arrow {
  display: block;
  -ms-transform: rotate(45deg); /* IE 9 */
  -webkit-transform: rotate(45deg); /* Chrome, Safari, Opera */
  transform: rotate(45deg);
  /* border-right: 2px solid #04f;
  border-bottom: 2px solid #04f; */
  border-right: 2px solid #fff45a;
  border-bottom: 2px solid #fff45a;
  margin: 0 0 0px 4px;
  width: 16px;
  height: 16px;
}
.arrow-top {
  margin-top: 1px;
}
.arrow-top,
.arrow-bottom {
  -webkit-animation: arrows-fade 1s infinite;
  -moz-animation: arrows-fade 1s infinite;
  animation: arrows-fade 1s infinite;
}
.arrow-top {
  -webkit-animation-delay: 0.1s;
  -moz-animation-delay: 0.1s;
  -webkit-animation-direction: alternate;
  animation-direction: alternate;
  animation-delay: alternate;
}
.arrow-bottom {
  -webkit-animation-delay: 0.2s;
  -moz-animation-delay: 0.2s;
  -webkit-animation-direction: alternate;
  animation-delay: 0.2s;
  animation-direction: alternate;
  margin-top: -6px;
}
@keyframes arrows-fade {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
@-webkit-keyframes arrows-fade {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
@-moz-keyframes arrows-fade {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
@-o-keyframes arrows-fade {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
@keyframes arrows-fade {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
</style>
